import { useMemo } from 'react';
import type { GroupBase, MenuListProps, OptionProps } from 'react-select';
import { components } from 'react-select';
import type { SelectorOption, SelectorOptionType } from '../../types';
import { SelectorOptionTypes } from '../../types';
import { getOptionsComponent } from '../../utils/getOptionsComponent';
import ChevronDown from '/public/icons/chevron-down.svg';

export const useGetBaseComponents = <T extends string | number>(
  optionType: SelectorOptionType = SelectorOptionTypes.DEFAULT
) => {
  const componentsMemo = useMemo(() => {
    const MenuList = (props: MenuListProps<SelectorOption<T>>) => {
      const isLoadingMore = props.selectProps.isLoading;
      return (
        <components.MenuList {...props}>
          {props.children}
          {isLoadingMore && <p className="text-body-regular text-grey-700 text-center py-1">Loading...</p>}
        </components.MenuList>
      );
    };

    const NoOptionsMessage = (props: { selectProps: { inputValue: string } }) => {
      const inputVal = props.selectProps.inputValue;
      if (!inputVal || inputVal.length < 2) {
        return <p className="text-body-regular text-grey-700 text-center py-1">Please enter 2 or more characters</p>;
      }
      return <p className="text-body-regular text-grey-700 text-center py-1">No options</p>;
    };

    const LoadingMessage = () => null;

    const DropdownIndicator = (props: { selectProps: { menuIsOpen: boolean } }) => (
      <ChevronDown
        className={`transition-transform duration-200 text-black fill-current w-4 h-4 ${
          props.selectProps.menuIsOpen ? 'rotate-180' : ''
        }`}
      />
    );

    const OptionComponent = getOptionsComponent(optionType);
    const Option = (props: OptionProps<SelectorOption<T>, false, GroupBase<SelectorOption<T>>>) => (
      <OptionComponent {...props} intent="default" />
    );

    return { MenuList, NoOptionsMessage, LoadingMessage, DropdownIndicator, Option };
     
  }, [optionType]);

  return componentsMemo;
};
